import React from 'react';
import './Btn.css'
import { Link } from 'react-router-dom';

const Btn = (props) => {
    return ( 
        <Link to='/'>
            <button className={props.BtnStyle}>{props.BtnText}</button>
        </Link>
     );
}
 
export default Btn;